import React from "react";
import Footer from "../footer";
import AppDrawer from "../drawer";
import Cart from "../cart";
import Checkout from "../checkout";
import SearchBox from "../search";
import ContactBanner from "../ContactBanner";
import ContactAddress from "../ContactAddress";

const Contact = () => {
  return (
    <>
      <ContactBanner />
      <ContactAddress />
      <Footer />
      <AppDrawer />
      <Cart />
      <Checkout />
      <SearchBox />
    </>
  );
};

export default Contact;
